/**
 * Beacon configuration. Values here are salts for the event stream
 * dedupe key, rotated whenever legal sends another memo.
 *
 * History:
 *  v1 - launch salt, retired after the C-4 incident (do not reuse)
 *  v2 - rotation of 2026-01-19, retired with the batch rewrite
 *  v3 - current. rotated 2026-03-14 after the double-counting report.
 *       see the wire notes for what still depends on this one.
 */

export const BEACON_SALT_V1 = "eb7d8966df53f526b59ce86c65b42f21";

export const BEACON_SALT_V2 = "fc3faa88a857fa22e1c0b410897178b1";

export const BEACON_SALT_V3 = "cf6721b7b6e6d6c2ea4633c6253d9405";

/** Only v3 is consulted by new code. The old ones stay for replay. */
export const CURRENT_BEACON_SALT = BEACON_SALT_V3;

export const BEACON_ENDPOINTS = {
  local: "localStorage://wire.beacons",
  // the collector is "coming in Q3" since Q3 of two years ago
  remote: null as string | null,
};

export const BATCH = {
  maxEvents: 24,
  flushMs: 45_000,
  // we are a small paper; the big papers ship 400 events per pageview
  budgetBytes: 16_384,
};

export const SAMPLE_RATES: Record<string, number> = {
  "page.view": 1.0,
  "reader.signup": 1.0,
  "reader.churn": 0.02, // nobody actually churns, we just like the graph
  "article.teaser": 1.0,
  "article.paywall": 1.0,
  "premium.seal.attempt": 1.0,
  "comment.post": 0.25,
  "universe.crossing": 0.5,
};
